"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterExternalStyleSheetsBase = void 0;
const Entities_1 = require("../../Entities");
class RegisterExternalStyleSheetsBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (castPayload.stylesheets === undefined) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = 'REGISTER_EXTERNAL_STYLESHEETS';
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { stylesheets } = this.castPayloadV1(payload);
                this.action(stylesheets);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.RegisterExternalStyleSheetsBase = RegisterExternalStyleSheetsBase;
